import { useState } from "react";

const TicketCategoriesChart = () => {
  const [hovered, setHovered] = useState(null);

  const categories = [
    { name: "Login", value: 65 },
    { name: "Technical", value: 80 },
    { name: "Learning Material", value: 40 },
    { name: "Quiz and Assessments-1", value: 60 },
  ];

  return (
    <div
      className="
        h-[330px]
        rounded-xl p-4
        bg-white dark:bg-slate-800
        border border-slate-200 dark:border-slate-700
        shadow-sm
        flex flex-col
      "
    >
      {/* TITLE */}
      <h6 className="text-base font-semibold text-slate-900 dark:text-slate-100">
        Ticket Categories
      </h6>

      {/* CONTENT – fills remaining height */}
      <div className="flex-1 flex flex-col justify-evenly mt-3">
        {categories.map((category, index) => (
          <div
            key={index}
            className="
              flex flex-col sm:flex-row
              sm:items-center
              gap-1 sm:gap-3
            "
          >
            {/* LABEL */}
            <div
              className="
                text-sm text-slate-600 dark:text-slate-400
                sm:w-[150px]
                truncate
              "
            >
              {category.name}
            </div>

            {/* BAR */}
            <div className="relative flex-1 h-3 rounded-full bg-[#E6E8FF] dark:bg-slate-700">
              <div
                onMouseEnter={() => setHovered(index)}
                onMouseLeave={() => setHovered(null)}
                className="
                  h-full rounded-full
                  transition-all duration-300
                  bg-[linear-gradient(90deg,#5A57FF_60%,#AAB1FF_100%)]
                "
                style={{ width: `${category.value}%` }}
              >
                {/* Tooltip (desktop only) */}
                {hovered === index && (
                  <div
                    className="
                      hidden sm:block
                      absolute -top-8 left-1/2 -translate-x-1/2
                      text-sm px-2 py-1
                      rounded
                      bg-slate-900 text-white
                      shadow-md
                      whitespace-nowrap
                    "
                  >
                    {category.value}%
                  </div>
                )}
              </div>
            </div>

            {/* MOBILE % */}
            <div className="sm:hidden text-sm font-medium text-slate-700 dark:text-slate-300">
              {category.value}%
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TicketCategoriesChart;